import { Type } from 'class-transformer';
import { AchievementBadgeResultDto } from './achievement-badge-result-dto';
import { CertificateResultDto } from './certificate-result-dto';
import { DegreeResultDto } from './degree-result-dto';

export class UserBiographyResultDto {
    name: string;
    displayName: string;
    imageBase64Data: string;
    businessRoleTitle: string;
    businessRoleHelpKey: string;
    managementCompany: string;
    location: string;
    satelliteOffice: string;
    department: string;
    departmentEmail: string;
    assignmentUrl: string;

    officePhone: string;
    mobilephone: string;
    shoretelPhone: string;
    email: string;
    supervisor: string;

    community: string;
    communityUrl: string;
    communityEmail: string;
    communityServiceTeamUrl: string;

    userBio: string; // Experience Summary

    @Type(() => DegreeResultDto)
    degrees: Array<DegreeResultDto>;

    @Type(() => CertificateResultDto)
    certificates: Array<CertificateResultDto>;

    @Type(() => AchievementBadgeResultDto)
    achievements: Array<AchievementBadgeResultDto>;

    isSuccessMessage: boolean;
    message: string;
    allowManageBio: boolean;

    // Transient Fields
    businessRoleHelpLink: string;

    get photoUrl(): string {
        return !!this.imageBase64Data && !!this.imageBase64Data.length
            ? this.imageBase64Data
            : 'assets/images/avatar_question_round.png';
    }
}
